import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserAuthService } from '../services/user-auth.service';
import { DeepLinkService } from '../../services/deep-link.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    readonly _userAuthService = inject(UserAuthService);
    readonly _router = inject(Router);
    readonly _deepLinkService = inject(DeepLinkService);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const expectedRoles = new Set<string>(route.data['roles'] || []);
        expectedRoles.add("Admin");
        const policies = new Set(this._userAuthService.userRoles.flatMap(role => role.policys ?? [])
        .map(policy => policy?.name).filter(name => name));

        const hasStandardPolicy = Array.from(policies).some(p => p?.includes('Standard'));
        const expectsStandard = Array.from(expectedRoles).includes('*Standard');

        const hasDeveloperPolicy = Array.from(policies).some(p => p?.includes('Developer'));
        const expectsDeveloper = Array.from(expectedRoles).includes('*Developer');
        
        const hasRole = expectedRoles.size === 0 
        || Array.from(expectedRoles).some(policy => policies.has(policy)) 
        || (hasStandardPolicy && expectsStandard)
        || (hasDeveloperPolicy && expectsDeveloper);

        if (!hasRole && !this._deepLinkService.hasPendingUrl()) {
            this._router.navigate(['/no-permission']);
        }

        return hasRole;
    }
}